import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const ADMIN_EMAIL = 'yjc801@gmail.com';

function PrivateRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (requireAdmin && (!user || user.email.toLowerCase() !== ADMIN_EMAIL)) {
    return <Navigate to="/groups" replace />;
  }

  return isAuthenticated ? children : <Navigate to="/" />;
}

export default PrivateRoute;
